import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'appHooks'
import { DEFAULT_PAGE_TAKE } from 'shared/constants/filters'
import {
  ISubleaseFilters,
  SubleaseSortFieldEnum,
  SubleaseSortOrderEnum,
  SubleaseStatusEnum,
} from '../../models/Sublease'

export const subleaseInitialFilters = {
  sortColumn: SubleaseSortFieldEnum.fromDate,
  sortorder: SubleaseSortOrderEnum.desc,
  take: DEFAULT_PAGE_TAKE,
  skip: 0,
  statuses: [SubleaseStatusEnum.ongoing],
} as ISubleaseFilters

const subleaseFiltersSlice = createSlice({
  name: 'subleaseFilters',
  initialState: subleaseInitialFilters,
  reducers: {
    patchSubleaseFilters: (
      state,
      action: PayloadAction<Partial<ISubleaseFilters>>
    ) => ({ ...state, ...action.payload }),
    resetSubleaseFilters: () => subleaseInitialFilters,
  },
})

export const getSubleaseFilters = (state: RootState) => state.subleaseFilters

export const { patchSubleaseFilters, resetSubleaseFilters } =
  subleaseFiltersSlice.actions

export default subleaseFiltersSlice
